export const COMMUNITY_DETAILS_TABS_NAMES = {
  SUMMARY: "Summary",
  HOMES: "Homes",
  CONTACTS: "Contacts",
  SUPPLIERS: "Suppliers",
  INSPECTION_AUTHORITIES: "Inspection Authorities",
};

export const COMMUNITY_DETAILS_TAB_ROUTES = {
  SUMMARY: "summary",
  HOMES: "homes",
  CONTACTS: "contacts",
  SUPPLIERS: "suppliers",
  INSPECTION_AUTHORITIES: "inspection-authorities",
};

export const COMMUNITY_DETAILS_TABS = [
  { label: COMMUNITY_DETAILS_TABS_NAMES.SUMMARY, value: COMMUNITY_DETAILS_TAB_ROUTES.SUMMARY },
  { label: COMMUNITY_DETAILS_TABS_NAMES.HOMES, value: COMMUNITY_DETAILS_TAB_ROUTES.HOMES },
  { label: COMMUNITY_DETAILS_TABS_NAMES.CONTACTS, value: COMMUNITY_DETAILS_TAB_ROUTES.CONTACTS },
  { label: COMMUNITY_DETAILS_TABS_NAMES.SUPPLIERS, value: COMMUNITY_DETAILS_TAB_ROUTES.SUPPLIERS },
  { label: COMMUNITY_DETAILS_TABS_NAMES.INSPECTION_AUTHORITIES, value: COMMUNITY_DETAILS_TAB_ROUTES.INSPECTION_AUTHORITIES },
];
